import { useEffect } from "react";
import { Layout } from "components";
import ReactGA from "react-ga4";

import { CircularProgress, Grid2 } from "@mui/material";

import { useBookingById } from "../api/hooks/useBookingById/useBookingById.ts";
import BookingInfo from "../components/BookingInfo/BookingInfo.tsx";

const BookingById = () => {
  const { data, isFetching } = useBookingById();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.href,
      title: "BOOKING_DETAILS_PAGE",
    });
  }, []);

  if (isFetching) {
    return (
      <Grid2 mt={2} container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    );
  }

  if (!data) return null;

  return (
    <Layout>
      <BookingInfo booking={data} />
    </Layout>
  );
};

export default BookingById;
